/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { BydGenerateParams, BydModel } from '@sixense/byd-core-service';
import { Params } from '@angular/router';
import { BydReport } from '../../../shared/models/byd-report.model';
import { BydReportInterface } from '../../../shared/interfaces/byd-report.interface';

@Injectable({
  providedIn: 'root',
})
export class DocsReportsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get All docs reports.
   *
   * @param projectId The Project ID
   * @param queryParams Filter queryparams.
   * @param pageIndex Page index.
   * @param elementsPerPage Elements per page.
   * @returns Observable<docsTemplateResponse>
   */
  public getAllReports(
    projectId: number,
    queryParams?: Params,
    pageIndex = 0,
    elementsPerPage = 20
  ): Observable<BydModel<BydReport>> {
    this.path = `/v1/bimdata/projects/${projectId}/exports`;
    const params = BydGenerateParams(queryParams);
    const headers = this.bydRhsHeadersService.setHeadersWithPagination(elementsPerPage, pageIndex);
    return this.getModels<BydReport>({ headers, params });
  }

  /**
   * Download doc report by ID.
   *
   * @param projectId Project Id.
   * @param reportId Report Id.
   * @returns Observable of Blob.
   */
  public downloadReport(projectId: number, reportId: string): Observable<Blob> {
    this.path = `/v1/bimdata/projects/${projectId}/exports/${reportId}/download`;
    return this.get<Blob>({ responseType: 'blob' });
  }

  /**
   * Create Report Template Response instance.
   *
   * @param jsonObject Template reponse.
   * @returns docTemplateResponse.
   */
  public createNewInstance(jsonObject: BydReportInterface): BydReport {
    return new BydReport(jsonObject);
  }
}
